import { TrailingNode as BaseTrailingNode } from "@tiptap/extensions";

export const TrailingNode = BaseTrailingNode.extend({
  onCreate() {
    // The trailing-node plugin needs a transaction to append a paragraph.
    // Trigger it on creation so posts ending in media have a place to type.
    // Exclude this initialization from undo history and onUpdate.
    this.editor.view.dispatch(
      this.editor.state.tr
        .setMeta("addToHistory", false)
        .setMeta("preventUpdate", true),
    );
  },
}).configure({ node: "paragraph" });
